module.exports = __webpack_public_path__ + "static/img/banner_2.504cd23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_2.jpg
// module id = S29U
// module chunks = 21